import React from 'react';
import { AlertCircle, CreditCard } from 'lucide-react';
import ReusableDropdown from '../../../components/ReusableDropdown';
import DatePicker from '../../../components/DatePicker';
import { getStyles } from '../styles/configurationStyles';
import { text } from '../constants/configurationText';

const toDateInput = (value) => (value ? new Date(value).toISOString().split('T')[0] : '');

const SubscriptionDetails = ({ theme, styles: passedStyles, t = text.en, permissions, onChange }) => {
  const styles = passedStyles || getStyles(theme);
  const pickerTheme = theme === 'light' ? 'light' : 'dark';
  const isRTL = t.lang === 'ar';

  const isExpired =
    permissions.subscriptionEndDate &&
    new Date(permissions.subscriptionEndDate) < new Date();

  return (
    <div style={styles.subCard}>
      <div style={styles.subCardHeader}>
        <div style={styles.subCardTitleRow}>
          <span style={styles.subCardIcon}>
            <CreditCard size={18} />
          </span>
          <h4 style={styles.subCardTitle}>{t.subscriptionDetails}</h4>
        </div>
      </div>

      <div style={styles.fieldGrid(200)}>
        <div>
          <label style={styles.fieldLabel}>{t.startDate}</label>
          <DatePicker
            theme={pickerTheme}
            isRTL={isRTL}
            value={toDateInput(permissions.subscriptionStartDate)}
            onChange={(value) => onChange('subscriptionStartDate', value ? new Date(value) : null)}
          />
        </div>
        <div>
          <label style={styles.fieldLabel}>{t.endDate}</label>
          <DatePicker
            theme={pickerTheme}
            isRTL={isRTL}
            value={toDateInput(permissions.subscriptionEndDate)}
            onChange={(value) => onChange('subscriptionEndDate', value ? new Date(value) : null)}
          />
        </div>
        <div>
          <label style={styles.fieldLabel}>{t.tier}</label>
          <ReusableDropdown
            items={[
              { id: 'basic', label: t.tiers.basic },
              { id: 'standard', label: t.tiers.standard },
              { id: 'premium', label: t.tiers.premium },
              { id: 'enterprise', label: t.tiers.enterprise },
            ]}
            value={permissions.subscriptionTier || 'basic'}
            onChange={(value) => onChange('subscriptionTier', value)}
            getItemKey={(item) => item.id}
            getItemLabel={(item) => item.label}
            searchable={false}
            theme={pickerTheme}
            language={t.lang}
            inputStyle={styles.field}
          />
        </div>
      </div>

      <div style={styles.groupTitle}>{t.quotas}</div>
      <div style={styles.fieldGrid(220)}>
        <div>
          <label style={styles.fieldLabel}>{t.dataQuota}</label>
          <input
            type="number"
            min="0"
            className="cfg-input"
            value={permissions.maxEmployees ?? ''}
            onChange={(e) => onChange('maxEmployees', e.target.value === '' ? null : Number(e.target.value))}
            placeholder={t.unlimited}
            style={styles.field}
          />
        </div>
        <div>
          <label style={styles.fieldLabel}>{t.accountQuota}</label>
          <input
            type="number"
            min="0"
            className="cfg-input"
            value={permissions.maxUsers ?? ''}
            onChange={(e) => onChange('maxUsers', e.target.value === '' ? null : Number(e.target.value))}
            placeholder={t.unlimited}
            style={styles.field}
          />
        </div>
      </div>
      <p style={styles.hint}>
        {t.quotaHint}
      </p>

      {isExpired && (
        <div style={{ ...styles.notice('danger'), marginTop: '14px', alignItems: 'center' }}>
          <AlertCircle size={16} />
          {t.expired}
        </div>
      )}
    </div>
  );
};

export default SubscriptionDetails;
